/**
 * BrandCardsSkeleton - Loading state for brand cards grid
 *
 * Shows 5 skeleton items matching the grid layout
 */

import { Skeleton } from '../../../Theme'
import { SKELETON_COUNTS } from '../../constants'

const BRAND_CARDS_GRID_CLASSES = 'grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 xl:grid-cols-5'
const BRAND_CARD_SKELETON_CLASSES = 'aspect-[2/1] rounded-lg border border-border-color shadow-sm'

export function BrandCardsSkeleton() {
  return (
    <>
      {/* Reserve the SectionHeader space the loaded grid renders, so the title doesn't pop in */}
      <Skeleton className="h-10 w-64 mx-auto mb-4" aria-hidden="true" />
      <div
        className={BRAND_CARDS_GRID_CLASSES}
        aria-busy="true"
        aria-label="Loading brand cards"
      >
        {Array.from({ length: SKELETON_COUNTS.brandCards }).map((_, index) => (
          <Skeleton key={index} className={BRAND_CARD_SKELETON_CLASSES} />
        ))}
      </div>
    </>
  )
}
